import {Component, OnInit} from '@angular/core';
import {AppService} from '../../services/app/app.service';

/**
 * Angular default mappings
 */
@Component({
  selector: 'app-please-wait',
  templateUrl: './please-wait.component.html',
  styleUrls: ['./please-wait.component.scss']
})
export class PleaseWaitComponent implements OnInit {

  /**
   * Default ctor
   * @param appService provided by DI
   */
  constructor(public appService: AppService) {
    this.appService = appService;
  }

  /**
   * Default initialization
   */
  ngOnInit() {
    this.appService.pleaseWaitView = this;
  }

}
